'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutContainer, PromoBanner, TextPassage } from '@petsmart-ui/sparky';
import { usePathname } from 'next/navigation';
import { trackBannerClick } from './analytics';
import type { BannerProps } from './types';
import { getBannerDisplay } from './utils';
import './banner.scss';
export type { BannerProps } from './types';
export function Banner(props) {
  const $ = _c(25);
  const {
    size,
    inverted,
    align,
    image,
    cta,
    onClick
  } = props;
  const pathname = usePathname();
  let t0;
  if ($[0] !== props) {
    t0 = getBannerDisplay(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const display = t0;
  let t1;
  if ($[2] !== onClick || $[3] !== pathname || $[4] !== props) {
    t1 = () => {
      trackBannerClick(props, pathname);
      onClick?.();
    };
    $[2] = onClick;
    $[3] = pathname;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = cta?.href;
  const t3 = cta?.target;
  const t4 = cta?.label;
  const t5 = cta?.variant;
  const t6 = align === "center";
  let t7;
  if ($[6] !== display.description || $[7] !== display.descriptionSize) {
    t7 = display.description && <TextPassage size={display.descriptionSize}>{display.description}</TextPassage>;
    $[6] = display.description;
    $[7] = display.descriptionSize;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== display.headingTagName || $[10] !== display.showCta || $[11] !== display.title || $[12] !== image.alt || $[13] !== image.sources || $[14] !== image.src || $[15] !== inverted || $[16] !== size || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <LayoutContainer className="banner-container"><PromoBanner data-testid="sparky-banner-test-id" title={display.title} imageItems={image.sources} imgSrc={image.src} imgAlt={image.alt} cta={display.showCta} onClick={t1} headingTagName={display.headingTagName} href={t2} target={t3} linkLabel={t4} buttonVariant={t5} size={size} inverted={inverted} centerText={t6} className="promo-banner">{t7}</PromoBanner></LayoutContainer>;
    $[9] = display.headingTagName;
    $[10] = display.showCta;
    $[11] = display.title;
    $[12] = image.alt;
    $[13] = image.sources;
    $[14] = image.src;
    $[15] = inverted;
    $[16] = size;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}